import { useCallback, useState } from "react";
import { useQuery } from "react-query";
import { stringify } from "query-string";
import { mutateErrors } from "../../../utils";
import { useProgramConfigSecondary } from "../../program/modals/secondary/hooks/useProgramConfigSecondary";
import { useIntakeConfigSecondary } from "../../program/modals/hooks/useIntakeConfigSecondary";
import { useSchoolId } from "../../school/hooks/useSchoolId";
import { useAcademicConfig } from "../modals/secondary/hooks/useAcademicConfig";
import useAcademicQueriesSecondary from "./useAcademicQueriesSecondary";
import { useHistory, useLocation } from "react-router";
import { replaceForURLOptions } from "../helpers/parseFilterToUrlOptions";

export const useAcademicsPageSecondary = (
  disableAutoFetch: boolean = false,
) => {
  const academicWizardConfigs = useAcademicConfig();
  const programWizardConfigs = useProgramConfigSecondary();
  const intakeWizardConfigs = useIntakeConfigSecondary();
  const history = useHistory();
  const location = useLocation();

  const { fetchAll } = useAcademicQueriesSecondary();
  const [filter, setFilter] = useState({});
  const schoolId = useSchoolId();

  const { isLoading, isError, error, data, refetch } = useQuery<any>(
    `academicsSecondaryList${schoolId}?${stringify(filter)}`,
    () => {
      return fetchAll({
        schoolId,
        ...filter,
      });
    },
    {
      enabled: !disableAutoFetch,
    },
  );

  const applyFilter = useCallback(
    (filter) => {
      setFilter({
        grade: filter.grade?.name,
        housingType: filter.housingType?.id,
        programType: filter.programType?.id,
        intake: filter.intake?.id,
      });

      history.replace({
        pathname: location.pathname,
        search: "?filters=" + JSON.stringify(replaceForURLOptions(filter)),
      });
    },
    [setFilter],
  );

  let errorMessage;
  if (isError) {
    const { message } = mutateErrors(error);
    errorMessage = message;
  }

  return {
    isLoading,
    isError,
    errorMessage,
    applyFilter,
    academicWizardConfigs,
    programWizardConfigs,
    intakeWizardConfigs,
    refetchAcademics: refetch,
    academics: data?.data || [],
  };
};
